var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalogues"},[_c('div',{staticClass:"catalogues__actions"},[_c('CreateCatalogueButton',{on:{"showModal":_vm.showModal}}),_c('CataloguesList')],1),_c('ModalCatalogues',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveModal),expression:"isActiveModal"}],on:{"closeModal":_vm.showModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }